export default __webpack_public_path__ + "static/media/2x1.c7f339a3.svg";